var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"formatted-text"},[_c('div',_vm._g({ref:"inner",domProps:{"innerHTML":_vm._s(_vm.renderedText)}},_vm.isTruncated ? { click: _vm.showRestOfText } : {}))])}
var staticRenderFns = []

export { render, staticRenderFns }